/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { DropdownDto } from './Api/Models';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
}
export default function GuardianType({ formik }: Props) {
  const selConst = useAppSelector(selectConstants);
  const [selected, setSelected] = React.useState<string>('');
  React.useEffect(() => {
    const guardianType = selConst.constantState.guardianTypes.find(
      (s) => s.id === formik.values.guardianTypeId
    );
    if (guardianType) setSelected(guardianType.description);
  }, [formik.values.guardianTypeId]);
  return (
    <>
      {selConst.constantState.guardianTypes && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.guardianTypeId &&
                Boolean(formik.errors.guardianTypeId)
              }
              id='demo-select-small'>
              Guardian Type
            </InputLabel>
            <Select
              required
              name='guardianTypeId'
              labelId='demo-select-small'
              id='demo-select-small'
              value={formik.values.guardianTypeId}
              label='Guardian Type'
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.setFieldValue('guardianTypeId', e.target.value);
                formik.setFieldValue('guardianTypeOptionId', 0);
              }}
              error={
                formik.touched.guardianTypeId &&
                Boolean(formik.errors.guardianTypeId)
              }>
              <MenuItem value={0} disabled>
                Select Guardian Type
              </MenuItem>
              {selConst.constantState.guardianTypes.map(
                (data: DropdownDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {data.name}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>
          <Box
            sx={{
              maxWidth: '600px',
              marginLeft: 2,
              color: 'grey',
              fontSize: 10,
            }}>
            {selected}
          </Box>

          <ErrorBox>
          {formik.touched.guardianTypeId &&
              (formik.errors.guardianTypeId as React.ReactNode)}
                                                            </ErrorBox>
       
        </>
      )}
    </>
  );
}
